import { BusinessDetails } from '../../slices/businessDetails';
import { CoverDetails } from '../../slices/coverDetails';
import { ExtraInfo } from '../../slices/extraInfo';
import { Quote } from '../../slices/quote';
import { Cover } from '../../types/cover';
import { InterestedPartyUI, Risk, RiskLocation } from '../../types/policy';
import { OccupationsListItem } from '../../types/refData';
import { Nullable } from '../../types/utils';
import { interestedPartyUtils } from '../../utils';
import { coverToRisk } from './coverToRisk';
import { RiskMetaType } from './getRiskMeta';

export const getUniqueRiskList = (options: {
  riskMeta: RiskMetaType;
  coverDetails: Nullable<CoverDetails>;
  extraInfo: Nullable<ExtraInfo>;
  isPropertyOwner: boolean;
  businessLocation: RiskLocation;
  businessDetails: Partial<BusinessDetails>;
  quote: Nullable<Quote>;
  requestCovers: Cover[];
  interestedParties: InterestedPartyUI[] | undefined;
  propertyOwnerOccupation: OccupationsListItem | undefined;
}) => {
  const requestInterestedParties = [
    ...(options.interestedParties ?? options.extraInfo.interestedParties!),
  ];
  return options.requestCovers
    .map((selectedCover) => {
      const risk = coverToRisk(selectedCover, options);
      const parties = interestedPartyUtils.getInterestedPartiesFromRisk(
        risk.riskClassCode,
        requestInterestedParties
      );

      return {
        ...risk,
        ...(parties.length > 0
          ? {
              interestedParties: parties,
            }
          : {}),
      };
    })
    .reduce((unique: Risk[], o) => {
      if (!unique.some((obj) => obj.riskClassCode === o.riskClassCode)) {
        unique.push(o);
      }
      return unique;
    }, [])
    .map((risk, index) => ({
      ...risk,
      riskNumber: index,
    }));
};
